import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const TemplatesEmptyState = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 128 128" {...props}>
    <path
      d="M115.84 71.808C115.839 64.1676 114.129 56.6242 110.833 49.7309C107.538 42.8377 102.742 36.7693 96.7965 31.9706C90.851 27.172 83.9069 23.7649 76.4734 21.999C69.0398 20.2332 61.3053 20.1534 53.837 21.7655C46.3686 23.3776 39.3556 26.6407 33.3124 31.3156C27.2691 35.9905 22.3488 41.9586 18.912 48.7824C15.4753 55.6063 13.6093 63.1127 13.4509 70.7515C13.2926 78.3902 14.8458 85.9676 17.9967 92.928H111.283C114.293 86.2941 115.847 79.0926 115.84 71.808Z"
      fill="#F5F4F4"
    />
    <path d="M14.08 92.928H113.92" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8.31995 92.928H11.5199"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M116.48 92.928H119.68" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M115 103.5C115 104.816 94.2621 106 68.4906 106C42.719 106 22 104.882 22 103.5C22 102.118 42.7379 101 68.4906 101C94.2433 101 115 102.184 115 103.5Z"
      fill="#F5F4F4"
    />
    <path d="M59.2435 89.0958H70.6446V95.9371H59.2435V89.0958Z" fill="white" />
    <path
      d="M59.2435 89.0958H70.6446V95.9371H59.2435V89.0958Z"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.7662 100.498H50.1228C50.1228 99.8985 50.2408 99.3052 50.4702 98.7515C50.6995 98.1979 51.0356 97.6948 51.4593 97.2711C51.8831 96.8474 52.3861 96.5113 52.9398 96.2819C53.4934 96.0526 54.0868 95.9346 54.686 95.9346H75.2088C76.418 95.9361 77.5772 96.4176 78.4317 97.2732C79.2862 98.1288 79.7662 99.2886 79.7662 100.498Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M100.289 42.3496C100.289 41.6009 100.142 40.8595 99.8554 40.1678C99.569 39.476 99.1491 38.8475 98.6197 38.318C98.0904 37.7885 97.4619 37.3685 96.7702 37.082C96.0785 36.7954 95.3372 36.6479 94.5885 36.6479H35.3005C34.5518 36.6479 33.8104 36.7954 33.1187 37.082C32.427 37.3685 31.7986 37.7885 31.2692 38.318C30.7398 38.8475 30.32 39.476 30.0336 40.1678C29.7472 40.8595 29.5998 41.6009 29.6 42.3496V79.9752H100.289V42.3496Z"
      fill="#E6FFF7"
    />
    <path
      d="M100.289 42.3496C100.289 41.6009 100.142 40.8595 99.8554 40.1678C99.569 39.476 99.1491 38.8475 98.6197 38.318C98.0904 37.7885 97.4619 37.3685 96.7702 37.082C96.0785 36.7954 95.3372 36.6479 94.5885 36.6479H35.3005C34.5518 36.6479 33.8104 36.7954 33.1187 37.082C32.427 37.3685 31.7986 37.7885 31.2692 38.318C30.7398 38.8475 30.32 39.476 30.0336 40.1678C29.7472 40.8595 29.5998 41.6009 29.6 42.3496V79.9752H100.289V42.3496Z"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M94.5885 89.0957C95.3371 89.0957 96.0783 88.9482 96.77 88.6618C97.4616 88.3753 98.09 87.9554 98.6193 87.426C99.1487 86.8967 99.5686 86.2683 99.855 85.5767C100.142 84.885 100.289 84.1438 100.289 83.3952V79.9751H29.6V83.3952C29.6 84.907 30.2006 86.357 31.2696 87.426C32.3387 88.4951 33.7886 89.0957 35.3005 89.0957H94.5885Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.5939 84.5359C63.5939 84.8943 63.7363 85.238 63.9897 85.4915C64.2431 85.7449 64.5869 85.8873 64.9453 85.8873C65.3037 85.8873 65.6474 85.7449 65.9009 85.4915C66.1543 85.238 66.2967 84.8943 66.2967 84.5359C66.2967 84.1774 66.1543 83.8337 65.9009 83.5803C65.6474 83.3268 65.3037 83.1844 64.9453 83.1844C64.5869 83.1844 64.2431 83.3268 63.9897 83.5803C63.7363 83.8337 63.5939 84.1774 63.5939 84.5359Z"
      fill="#622C6A"
    />
    <path
      d="M36.4519 42.0007H93.4372V50.0074H36.4519V42.0007Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.437 79.9749H77.4072V55.7957C77.4072 55.4853 77.5305 55.1877 77.7499 54.9683C77.9694 54.7489 78.267 54.6256 78.5773 54.6256H92.2669C92.5773 54.6256 92.8749 54.7489 93.0943 54.9683C93.3137 55.1877 93.437 55.4853 93.437 55.7957V79.9749Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.4519 54.6256H72.0743V62.6323H36.4519V54.6256Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.1898 67.2498H72.0753V75.2565H57.1898V67.2498Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.4519 67.2498H51.3374V75.2565H36.4519V67.2498Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5527 71C23.5527 69.8954 24.4482 69 25.5527 69H37.8727C38.9773 69 39.8727 69.8954 39.8727 71V96.92C39.8727 98.0246 38.9773 98.92 37.8727 98.92H25.5527C24.4482 98.92 23.5527 98.0246 23.5527 96.92V71Z"
      fill="white"
      stroke="#4550E5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5527 71C23.5527 69.8954 24.4482 69 25.5527 69H37.8727C38.9773 69 39.8727 69.8954 39.8727 71V96.92C39.8727 98.0246 38.9773 98.92 37.8727 98.92H25.5527C24.4482 98.92 23.5527 98.0246 23.5527 96.92V71Z"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M23.5527 72.3997H39.8727V95.519H23.5527V72.3997Z" fill="#E6FBFF" />
    <path
      d="M36.3399 77.0704C36.34 77.2842 36.298 77.496 36.2163 77.6936C36.1345 77.8912 36.0146 78.0708 35.8634 78.222C35.7121 78.3732 35.5326 78.4932 35.335 78.5749C35.1374 78.6567 34.9256 78.6987 34.7117 78.6985H28.7136C28.2899 78.6866 27.8875 78.51 27.592 78.206C27.2964 77.9021 27.1311 77.4949 27.1311 77.071C27.1311 76.6471 27.2964 76.2399 27.592 75.936C27.8875 75.632 28.2899 75.4554 28.7136 75.4435H34.7117C34.9254 75.4433 35.1371 75.4853 35.3347 75.567C35.5322 75.6486 35.7117 75.7684 35.8629 75.9195C36.0141 76.0706 36.1341 76.25 36.2159 76.4475C36.2977 76.645 36.3399 76.8566 36.3399 77.0704Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.0868 82.3325H36.3399V92.3754H27.0868V82.3325Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5527 72.3997H39.8727V95.519H23.5527V72.3997Z"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.8689 60C80.8689 58.8954 81.7643 58 82.8689 58H111.405C112.51 58 113.405 58.8954 113.405 60V97.4234C113.405 98.5279 112.51 99.4234 111.405 99.4234H82.8689C81.7643 99.4234 80.8689 98.5279 80.8689 97.4234V60Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.6781 63.3069H109.597V94.1178H84.6781V63.3069Z"
      fill="#FFF8D9"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.3428 67.0853H105.931V72.6124H88.3428V67.0853Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M100.715 75.9481H105.931V90.3379H100.715V75.9481Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.3428 75.9481H97.1376V81.4752H88.3428V75.9481Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.3428 84.8108H97.1376V90.3378H88.3428V84.8108Z"
      fill="white"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.26 100H80.07C80.1805 100 80.27 100.09 80.27 100.2V100.7C80.27 100.866 80.1357 101 79.97 101H79.26V100Z"
      fill="#622C6A"
    />
  </SvgIcon>
);
